import FormAutocomplete from 'components/Control/Form/FormAutocomplete'
import FormCheckbox from 'components/Control/Form/FormCheckbox'
import FormDatePicker from 'components/Control/Form/FormDatePicker'
import FormInput from 'components/Control/Form/FormInput'
import FormInputPassword from 'components/Control/Form/FormInputPassword'
import FormSelect from 'components/Control/Form/FormSelect'
import FormSwitch from 'components/Control/Form/FormSwitch'

const formComponents = {
    password: FormInputPassword,
    select: FormSelect,
    autocomplete: FormAutocomplete,
    checkbox: FormCheckbox,
    datepicker: FormDatePicker,
    switch: FormSwitch,
}

export const getFormComponent = (type) => {
    return formComponents[type] || FormInput
}
export const resetSectionFields = (fields, reset) => {
    Object.values(fields).forEach((field) => {
        resetField(field.name, reset)
    })
}
export const resetField = (field, resetField) => {
    resetField(field)
}
